import CEvent from './customEvent';

class UserEvents {
  constructor() {
    this.settings = {
      bubbles: true,
      cancelable: false,
    };

    this.eventLogin = "login";
    this.eventAccountRegistration = "account_registration";
    this.eventCreatedAccount = "createdAccount";
    this.eventLogout = "logout";
    this.eventLoginFailed = "loginFailed";
    this.eventCreateFailed = "createFailed";
    this.eventResetPasswordSent = "resetpasswordsent";
    this.eventResetPasswordSuccess = "resetPasswordSuccess";

    this.login = user => {
      return CEvent(this.eventLogin, user);
    };

    this.created = user => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: this.eventAccountRegistration,
        profile_type: user.profileType,
      });
      return CEvent(this.eventCreatedAccount, user);
    };

    this.logout = () => new CustomEvent(this.eventLogout, this.settings);

    this.loginFailed = response => {
      return CEvent(this.eventLoginFailed, response);
    };

    this.createFailed = response => {
      return CEvent(this.eventCreateFailed, response);
    };

    this.resetPasswordSent = response => {
      return CEvent(this.eventResetPasswordSent, response);
    };

    this.resetPasswordSuccess = response => {
      return CEvent(this.eventResetPasswordSuccess, response);
    };
  }
}

export default UserEvents;
